import classNames from "classnames"
import useReportScrolledIntoView from "hooks/useReportScrolledIntoView"
import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import t from "translations/index"
import AppCard from "./AppCard"
import css from "./AppCollection.module.scss"
import { Column, Row } from "./Layout"

const AppCollection = ({
  id,
  total,
  limit,
  title = null,
  layout = "vertical",
  cardType = "default",
  showIcon = true,
  showBanner = false,
  showVideo = false,
  apps = [],
  style,

  appCollection = null, // for reporting
  tab = null // for reporting
}) => {
  const appCollectionRef = useRef()
  useReportScrolledIntoView(appCollectionRef, "discover", "app collection shown", {
    tab,
    appCollection
  })

  // Only for horizontal layout
  const appCollectionScrollRef = useRef()
  const [scrollMileStones, setScrollMileStones] = useState({})
  useEffect(() => {
    if (layout !== "horizontal") return

    const el = appCollectionScrollRef?.current
    if (!el) return

    const updatePosition = (e) => {
      const scrollPcent = el.scrollLeft / (el.scrollWidth - el.getBoundingClientRect().width)
      const normalized = Math.floor(Math.round(scrollPcent * 100) / 25)

      if (normalized > 0 && !scrollMileStones[normalized]) {
        setScrollMileStones({ ...scrollMileStones, [normalized]: true })
      }
    }

    el.addEventListener("scroll", updatePosition)

    // 👇️ remove the event listener when component unmounts
    return () => {
      el.removeEventListener("scroll", updatePosition)
    }
  }, [appCollectionScrollRef, scrollMileStones])


  const appCards = apps.map((app, i) => {
    return (
      <AppCard
        key={app.id}
        id={app.id}

        // app metadata
        packageName={app.packageName}
        title={app.title}
        score={app.score}
        icon={app.icon}
        headerImage={app.headerImage}
        video={app.video}
        videoImage={app.videoImage}
        videoPreview={app.videoPreview}
        versionCode={app.versionCode}
        isPartnerApp={app.isPartnerApp}

        // Look and feel
        cardType={cardType}
        showIcon={showIcon}
        showBanner={showBanner}
        showVideo={showVideo}

        app={app}
        tab={tab}
        appCollection={appCollection}
      />
    )
  })

  let titleEl
  if (title) {
    titleEl = (
      <Row sf="msb" padding="md 1.5rem">
        <h5>{title}</h5>

        {total > limit && (
          <Link className={css.seeAll} to={`/app_collection/${id}`}>{t("see_all")}</Link>
        )}
      </Row>
    )
  }

  if (layout === "chart") {
    return (
      <Column
        ref={appCollectionRef}
        className={classNames(css.appCollection, css.charts)}
        padding="0 1.5rem"
        style={style}
      >
        {/* <div className={css.podium} sf="bsa" padding="lr-xxl">
          <div>1st</div>
          <div>2nd</div>
          <div>3rd</div>
        </div> */}
        <div className={css.chartList}>
          {appCards.map((card, i) => {
            return (
              <Row key={i} align="mc" padding="0 0 0 md">
                <div className={css.chartRank}>{i + 1}</div>
                <div col={1} style={{ minWidth: 0 }}>
                  {card}
                </div>
              </Row>
            )
          })}
        </div>
      </Column>
    )
  } else if (layout === "horizontal") {
    return (
      <div ref={appCollectionRef} className={css.appCollection} style={style}>
        {titleEl}
        <div
          ref={appCollectionScrollRef}
          className={classNames(css.appCards, css.horizontal)}
        >
          {appCards}
        </div>
      </div>
    )
  } else {
    return (
      <div ref={appCollectionRef} className={css.appCollection} style={style}>
        {titleEl}
        <Column className={classNames(css.appCards, css.vertical)} padding="0 1.5rem" gap="sm">
          {appCards}
        </Column>
      </div >
    )
  }
}

export default AppCollection
